import React from 'react';
import intl from 'react-intl-universal';
import styles from './knowledgeDialog.module.scss';

class KnowledgeDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }
  static defaultProps = {
    position: {},
    mini: false,
    isNeedTitleIcon: true
  }
  componentDidMount() {}
  render () {
    const {show, handleCancel, handleMini, position, title, isNeedTitleIcon, mini} = this.props;
    return (
      <div className={`${styles.knowledgeDialog} ${show ? styles.isShow: ''} ${mini ? styles.noPadding: ''}`} style={position}>
        {mini && <span className={styles.miniIcon} onClick={handleMini}></span>}
        <svg onClick={handleCancel} t="1605767008429" className={styles.deleteIcon} viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1174" width="19" height="19"><path d="M571.733333 512l226.133334-226.133333c17.066667-17.066667 17.066667-42.666667 0-59.733334s-42.666667-17.066667-59.733334 0L512 452.266667 285.866667 226.133333c-17.066667-17.066667-42.666667-17.066667-59.733334 0s-17.066667 42.666667 0 59.733334l226.133334 226.133333-226.133334 226.133333c-17.066667 17.066667-17.066667 42.666667 0 59.733334 8.533333 8.533333 17.066667 12.8 29.866667 12.8s21.333333-4.266667 29.866667-12.8l226.133333-226.133334 226.133333 226.133334c8.533333 8.533333 21.333333 12.8 29.866667 12.8s21.333333-4.266667 29.866667-12.8c17.066667-17.066667 17.066667-42.666667 0-59.733334L571.733333 512z" p-id="1175" fill="#bfbfbf"></path></svg>
        <div className={[styles.title, !isNeedTitleIcon ? styles.isNeedTitleIcon : '', mini ? styles.miniTitle : ''].join(' ')}>{title || `${intl.get('REPLAY_KNOWLEDGE_POINT_POINT')}`}</div>
        {this.props.children}
      </div>
    )
  }
}
export default KnowledgeDialog;
